export default __webpack_public_path__ + "static/media/cover.ebf72fe3.png";